import{AspectRatio as o}from"@mantine/core";import{jsx as r}from"@emotion/react/jsx-runtime";function p(t){return r(o,{...t})}var e=p;export{e as AspectRatio};
